export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const LOGO_URL =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_multi-segment-crm/artifacts/kjj39uxx_correcore2.png";

export const inr = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN");

export const DOCTOR_STAGES = [
  { key: "prospect_identified", label: "Prospect Identified" },
  { key: "outreach_initiated", label: "Outreach Initiated" },
  { key: "meeting_demo_held", label: "Meeting / Demo Held" },
  { key: "terms_discussed", label: "Terms Discussed" },
  { key: "agreement_signed", label: "Agreement Signed" },
  { key: "onboarded", label: "Onboarded" },
  { key: "active", label: "Active" },
  { key: "dormant_churned", label: "Dormant / Churned" },
];

export const CLINICIAN_STAGES = [
  { key: "sourced", label: "Sourced" },
  { key: "screened", label: "Screened" },
  { key: "credential_submitted", label: "Credential Submitted" },
  { key: "credentialing_approved", label: "Registry Approved" },
  { key: "contracted", label: "Contracted" },
  { key: "onboarded", label: "Onboarded" },
  { key: "active", label: "Active" },
  { key: "inactive", label: "Inactive" },
];

export const PATIENT_STAGES = [
  { key: "lead_referred", label: "Lead / Referred-in" },
  { key: "contacted", label: "Contacted" },
  { key: "package_explained", label: "Package Explained" },
  { key: "enrolled_paid", label: "Enrolled / Paid" },
  { key: "in_treatment", label: "In Treatment" },
  { key: "completed", label: "Completed" },
  { key: "retained_reengaged", label: "Retained / Re-engaged" },
  { key: "churned", label: "Churned" },
  { key: "lost", label: "Lost (no enrol)" },
];

export const CLOSED_PATIENT_STAGES = ["churned", "lost"];
export const ACTIVE_PATIENT_STAGES = PATIENT_STAGES.filter((s) => !CLOSED_PATIENT_STAGES.includes(s.key));
export const CLOSED_PATIENT_STAGE_DEFS = PATIENT_STAGES.filter((s) => CLOSED_PATIENT_STAGES.includes(s.key));
export const PATIENT_STAGE_COLOR = {
  lead_referred: "#94a3b8", contacted: "#94a3b8", package_explained: "#94a3b8",
  enrolled_paid: "#2540FF", in_treatment: "#0D9488", completed: "#10B981",
  retained_reengaged: "#10B981", churned: "#f43f5e", lost: "#64748b",
};
export const PAYMENT_DOT = { paid: "#10B981", unpaid: "#D97706", refunded: "#f43f5e" };
export const PAYMENT_METHODS = [
  { key: "upi", label: "UPI" }, { key: "card", label: "Card" },
  { key: "cash", label: "Cash" }, { key: "bank_transfer", label: "Bank transfer" },
];
export const LOST_REASONS = [
  { key: "price_too_high", label: "Price too high" }, { key: "not_reachable", label: "Not reachable" },
  { key: "chose_another_provider", label: "Chose another provider" }, { key: "not_interested", label: "Not interested" },
  { key: "location_timing", label: "Location / timing" }, { key: "other", label: "Other" },
];
export const OVERDUE_DAYS = 7;

export const LEAD_STAGES = [
  { key: "cold_lead", label: "Cold Lead" },
  { key: "contacted", label: "Contacted" },
  { key: "engaged", label: "Engaged" },
  { key: "qualified", label: "Qualified" },
  { key: "demo_scheduled", label: "Demo Scheduled" },
  { key: "proposal_sent", label: "Proposal Sent" },
  { key: "negotiation", label: "Negotiation" },
  { key: "converted", label: "Converted" },
  { key: "lost", label: "Lost" },
];

export const LEAD_TYPE_META = {
  doctor: { label: "Doctor", cls: "bg-amber-100 text-amber-700" },
  clinician: { label: "Clinician", cls: "bg-teal-100 text-teal-700" },
  patient: { label: "Patient", cls: "bg-blue-100 text-blue-700" },
};

export const INTEREST_META = {
  hot: { label: "Hot", cls: "bg-rose-100 text-rose-700" },
  warm: { label: "Warm", cls: "bg-amber-100 text-amber-700" },
  cold: { label: "Cold", cls: "bg-slate-100 text-slate-500" },
};

export const OWNERS = ["Priya R", "Arjun M", "Kavya S", "Rohit N", "Deepa V"];

export const ACTIVITY_META = {
  call: { label: "Call", color: "#2540FF" },
  email: { label: "Email", color: "#0D9488" },
  note: { label: "Note", color: "#64748b" },
  meeting: { label: "Meeting", color: "#D97706" },
  stage_change: { label: "Stage change", color: "#7C3AED" },
  conversion: { label: "Converted", color: "#10B981" },
};

export const labelOf = (stages, key) =>
  (stages.find((s) => s.key === key) || {}).label || key;

export const CRED_META = {
  pending: { label: "Pending", cls: "bg-slate-100 text-slate-600" },
  submitted: { label: "Submitted", cls: "bg-blue-100 text-blue-700" },
  verified: { label: "Verified", cls: "bg-emerald-100 text-emerald-700" },
  approved: { label: "Registry Approved", cls: "bg-teal-100 text-teal-700" },
  flagged: { label: "Flagged", cls: "bg-rose-100 text-rose-700" },
};

export const INDIA_CITIES = [
  "Mumbai", "Delhi", "Bengaluru", "Hyderabad", "Chennai", "Kolkata", "Pune",
  "Ahmedabad", "Jaipur", "Lucknow", "Chandigarh", "Kochi", "Coimbatore", "Indore",
  "Nagpur", "Bhopal", "Patna", "Surat", "Visakhapatnam", "Guwahati", "Bhubaneswar",
  "Thiruvananthapuram", "Madurai", "Ludhiana",
];
